import React, { useCallback, useEffect, useState } from 'react'
import { Tooltip } from '@mui/material'

import _ from 'lodash'
import { useSelector } from 'react-redux'
import { get } from 'services/api'
import { ErrorOutline } from '@mui/icons-material'
import styles from './styles'

const GreenhouseStage = ({ application }) => {
  const [tooltipMessage, setTooltipMessage] = useState('')
  const BACKGROUND_CHECK_STAGE_NAME = 'Background Check'
  const CREDIT_ANALYSIS_STAGE_NAME = 'Análise de Crédito'
  const LEGACY_CREDIT_ANALYSIS_STAGE_NAME = 'Reference Check'
  const token = useSelector(state => state.auth.access_token)


  const requestStages = useCallback(async () => {
    const backgroundCheckIsEmpty =
      _.isEmpty(application.background_check_summary) || application.background_check_summary.status == null
    const creditAnalysisIsEmpty =
      _.isEmpty(application.reference_check_summary) || application.reference_check_summary.status == null

    const checkStages = (stagesList) => {
      const currentStage = stagesList.find((stage) => stage.name === application.current_stage)
  
      if (!currentStage) {
        return
      }

      const backgroundCheckStage = stagesList.find((stage) => stage.name === BACKGROUND_CHECK_STAGE_NAME)
      const creditAnalysisStage = stagesList.find((stage) => stage.name === CREDIT_ANALYSIS_STAGE_NAME) || stagesList.find((stage) => stage.name === LEGACY_CREDIT_ANALYSIS_STAGE_NAME)


      if (
        backgroundCheckStage &&
        backgroundCheckIsEmpty &&
        currentStage.priority > backgroundCheckStage?.priority
      ) {
        setTooltipMessage('A aplicação avançou estágios sem se submeter ao Background Check')
      } else if (
        creditAnalysisStage &&
        creditAnalysisIsEmpty &&
        currentStage.priority > creditAnalysisStage.priority
      ) {
        setTooltipMessage('A aplicação avançou estágios sem se submeter à Análise de Crédito')
      }
    }

    if ([BACKGROUND_CHECK_STAGE_NAME, CREDIT_ANALYSIS_STAGE_NAME].includes(application.current_stage)) {
      return
    }
    if (!backgroundCheckIsEmpty && !creditAnalysisIsEmpty) {
      return
    }
    const res = await get({
      url: `/application/stages?application_uuid=${application.uuid}`,
      token: token,
      quiet: true,
    })

    if (!_.isEmpty(res)) {
      checkStages(res)
    }
  }, [])

  useEffect(() => {
    requestStages()
  }, [requestStages])

  const classes = styles()

  return (
    <Tooltip arrow title={tooltipMessage ? <h4>{tooltipMessage}</h4> : ''}>
      <span className={tooltipMessage ? classes.warningMessage : ''}>
        {tooltipMessage && <ErrorOutline fontSize='small'/>}
        <span style={{ color: 'black' }}>{application.current_stage}</span>
      </span>
    </Tooltip>
  )
}

export default GreenhouseStage
